<template>
    <div class="m-meun-left">
        <el-scrollbar style="height: 100%;" ref="scrolls">
            <el-menu :router="true"  v-if="menus && menus.length" ref="navbar" 
                class="nav2-con" :collapse="collapseTip" :default-active="activeMenuIndex" menu-trigger="click" theme="dark" unique-opened>
                <template  v-for="(item, n) in menus">
                    <nav-item :item="item" :key="n"  v-if="$_auth(item.auth) && item.isMenu"></nav-item>
                </template>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import navItem from './navItem'
import * as access from '@/config/access'
import { basicUrl,url } from '@/fetch/url'

export default {
    props:['collapseTip','menus'],
    data() {
        return {
            navBgShow: false
        }
    },
    
    components: {
        navItem
    },
    mounted(){
        this.list = this.data;
        window.addEventListener('resize', this.resetScroll, false);
    },
    methods: {

    },
    computed: {
        activeMenuIndex () {
            //这里优先获取vuex里面的值，没有值的时候，我们再取val
            let path = this.$route.meta && this.$route.meta.navIndex ? this.$route.meta.navIndex : this.$route.path;
            return (this.$store.state.navIndex || path) == '/' ?  '/goodsManage/esGoodsManage' : (this.$store.state.navIndex || path);
        }
    },
    resetScroll(){
        this.$refs.scrolls.update();
    },
    
    beforeDestroy(){
        window.removeEventListener('resize', this.resetScroll, false);
    },
    
}
</script>

<style lang="scss">
@import '../../style/variable';
.m-meun-left{
    /* .el-scrollbar__wrap{
        overflow-x: hidden; 
    } */
    .el-menu-item-group__title{
        padding: 0;
    }
    .nav2-con{
        padding-top: 90px;
        width: 220px;
        border: 0;
        background: $c34;
        &>.el-menu-item{
            color: $c33;
            &:hover,&:focus{
                background: $c4;
                color: $c1;
                i:before{
                    color: $c1;
                }
            }
        }
        /* .el-submenu{
            .el-submenu__icon-arrow{
                -ms-transform: rotateZ(-90deg);
                -moz-transform: rotateZ(-90deg);
                -o-transform: rotateZ(-90deg);
                -webkit-transform: rotateZ(-90deg);
                transform: rotateZ(-90deg);
            }
        } */
        /* .is-opened{
            &>.el-submenu__title{
                color: $c1;
                background: #182733;
                .nav-icon:before,.el-submenu__icon-arrow{
                    color: $c1;
                }
                .el-submenu__icon-arrow {
                    -ms-transform: rotateZ(0deg);
                    -moz-transform: rotateZ(0deg);
                    -o-transform: rotateZ(0deg);
                    -webkit-transform: rotateZ(0deg);
                    transform: rotateZ(0deg);
                }
            }
        } */
        .el-submenu__title{
            color: $c33;
            height: 50px;
            line-height: 50px;
            &:hover{
                background: $c4;
                color: $c1;
                .nav-icon:before,.el-submenu__icon-arrow{
                    color: $c1;
                }
            }
        }
        .el-menu-item-group{
            background: #15212b;
            .el-menu-item{
                color: $c33;
                height: 36px;
                width: 220px;
                padding: 0 20px;
                line-height: 36px;
                padding-left: 54px!important;
                &.is-active,&:hover{
                    background: $c4;
                    color: $c1;
                }
            }
        }
    }
}


</style>
